import { IPhongUuTienNhomActionTypes } from "../../action-types/category/IPhongUuTienNhomActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPhongUuTienNhomReducer } from "../../reducer-model/category/IPhongUuTienNhomReducer";

const initState: IPhongUuTienNhomReducer = {
  status: eReducerStatusBase.is_not_initialization,
  phongUuTienNhoms: [],
};
export const phongUuTienNhomReducer = (
  state: IPhongUuTienNhomReducer = initState,
  action: IPhongUuTienNhomActionTypes
): IPhongUuTienNhomReducer => {
  switch (action.type) {
    case "PHONG_UU_TIEN_NHOM_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "PHONG_UU_TIEN_NHOM_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, phongUuTienNhoms: action.payload };
    case "PHONG_UU_TIEN_NHOM_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "PHONG_UU_TIEN_NHOM_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, phongUuTienNhomEditing: action.payload };
    case "PHONG_UU_TIEN_NHOM_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "PHONG_UU_TIEN_NHOM_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "PHONG_UU_TIEN_NHOM_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "PHONG_UU_TIEN_NHOM_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "PHONG_UU_TIEN_NHOM_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "PHONG_UU_TIEN_NHOM_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "PHONG_UU_TIEN_NHOM_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
